// State Nodes
import { whereShipping } from './whereShipping'
import { selectProducts } from './selectProducts'
import { howWillInventoryArrive } from './howWillInventoryArrive'
import { addShippingConfigurations } from './addShippingConfigurations'
import { arrivalDetails } from './arrivalDetails'
import { reviewAndSubmit } from './reviewAndSubmit'

// Components
import WhereShippingComponent from '@/components/createWarehouseReceivingOrder/steps/WhereShipping'
import SelectProductsComponent from '@/components/createWarehouseReceivingOrder/steps/SelectProducts'
import HowWillInventoryArriveComponent from '@/components/createWarehouseReceivingOrder/steps/HowWillInventoryArrive'
import AddShippingConfigurationsComponent from '@/components/createWarehouseReceivingOrder/steps/addShippingConfigurations/AddShippingConfigurations'
import ArrivalDetailsComponent from '@/components/createWarehouseReceivingOrder/steps/ArrivalDetails'
import ReviewAndSubmitComponent from '@/components/createWarehouseReceivingOrder/steps/ReviewAndSubmit'

// to prevent circular dependencies, this gets exported as machineSteps from the create-order-machine
// if you need to use this, use that export
export const steps = [
  {
    stateNode: whereShipping,
    component: WhereShippingComponent
  },
  {
    stateNode: selectProducts,
    component: SelectProductsComponent
  },
  {
    stateNode: howWillInventoryArrive,
    component: HowWillInventoryArriveComponent
  },
  {
    stateNode: addShippingConfigurations,
    component: AddShippingConfigurationsComponent
  },
  {
    stateNode: arrivalDetails,
    component: ArrivalDetailsComponent
  },
  {
    stateNode: reviewAndSubmit,
    component: ReviewAndSubmitComponent
  }
]
